import { ButtonLink } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { Section, SectionHeading } from '@/components/ui/Section'
import { Notice } from '@/components/ui/Notice'
import { ROUTES } from '@/config/site'
import { CahayaGrid } from '@/features/cahaya/CahayaGrid'
import { Hero } from '@/features/countdown'
import { SiteList } from '@/features/expedition/SiteList'
import { NewsletterForm } from '@/features/subscribe/NewsletterForm'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function HomePage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.hero.theme, description: t.hero.lead })

  return (
    <>
      <Hero />

      <Section className="hairline">
        <SectionHeading eyebrow={t.cahaya.eyebrow} title={t.cahaya.heading} lead={t.cahaya.lead} />
        <div className="mt-6">
          <Notice>{t.cahaya.draftNotice}</Notice>
        </div>
        <div className="mt-8">
          <CahayaGrid />
        </div>
      </Section>

      <Section className="hairline">
        <SectionHeading
          eyebrow={t.expedition.eyebrow}
          title={t.expedition.heading}
          lead={t.expedition.lead}
        />
        <div className="mt-8">
          <SiteList />
        </div>
        <div className="mt-8">
          <ButtonLink to={ROUTES.expedition} variant="ghost">
            {t.common.learnMore}
          </ButtonLink>
        </div>
      </Section>

      <Section className="hairline" size="narrow">
        <Card className="text-center sm:p-10">
          <p className="eyebrow">{t.join.eyebrow}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl">{t.join.newsletterHeading}</h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-muted">{t.join.newsletterLead}</p>
          <div className="mx-auto mt-7 max-w-md">
            <NewsletterForm />
          </div>
        </Card>
      </Section>
    </>
  )
}
